import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'oiq-notification-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss'],
  imports: [RouterLink],
})
export class OiqNotificationEventsListComponent {
  @Input() items: any[] = [];
  @Output() event = new EventEmitter<{ type: 'string'; data: any }>();

  getFormatFromNow(datetime) {
    return moment(datetime).fromNow();
  }
}
